export const CoreError = {
    UserIsNotLoggedIn: 'UserIsNotLoggedIn',
    CustomerNotFound: 'CustomerNotFound',
    UnableToFetchUser: 'UnableToFetchUser',
} as const;
